<template>
  <div>
    <div
      class="extraInfo optionLine"
      :key="extra_index"
      v-for="(extra, extra_index) in extras"
      @click="editExtra(extra)"
    >
      -
      {{
        getTranslation($store, "Extra", "display_name", extra.id, extra.name)
      }}
      {{ extraPrice(extra) }}
      <span v-if="!scanned && !isV2EditOrder" class="extraImgEdit" />
    </div>
  </div>
</template>

<script>
import { getTranslation } from "@/utils/helpers";
import { toCalculatable, toPrintable } from "@/utils/pricing";
import { isV2EditOrder } from "@/utils/templateSettings";

export default {
  name: "ExtrasBlock",
  methods: {
    getTranslation,
    editExtra(extra) {
      if (!isV2EditOrder()) {
        this.$emit("editExtra", extra);
      }
    },
    extraPrice(extra) {
      let price = toCalculatable(extra.offset_price);
      if (price !== 0) {
        return "(" + toPrintable(price, true) + ")";
      } else {
        return "";
      }
    }
  },
  computed: {
    isV2EditOrder
  },
  props: {
    extras: Array,
    scanned: Number
  }
};
</script>

<style scoped>
.optionLine {
  display: flex;
  flex-direction: row;
}

.extraInfo {
  display: flex;
  font-family: var(--app_font-family_regular);
  color: var(--component_order_listitems_extrasBlock_extraInfo_color);
}

.extraImgEdit {
  background-image: var(
    --component_order_listitems_extrasBlock_extraImgEdit_background-image
  );
  background-size: contain;
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  margin-top: 2px;
}
</style>
